import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { commitMutation, graphql } from 'react-relay';
import { Button, Modal } from 'semantic-ui-react';
import UserPlaylist from './UserPlaylistQuery';
import {
  Analytics,
  GlobalNotifications,
  Intent,
  MobileModal
} from '../Modules';
import NewPlaylist from './NewPlaylist';
import PlaylistPreview from '../Playlist/Preview';
import { RootConsumer } from '../RootComponent';

class Playlists extends Component {
  static propTypes = {
    relay: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.onOpen = this.onOpen.bind(this);
    this.onClose = this.onClose.bind(this);
    this.openPlaylist = this.openPlaylist.bind(this);
    this.getSelectedPlaylist = this.getSelectedPlaylist.bind(this);
    this.deletePlaylist = this.deletePlaylist.bind(this);
    this.state = {
      open: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.viewer.playlists.edges.length !==
      this.props.viewer.playlists.edges.length
    ) {
      this.setState({ selectedPlaylistId: undefined });
    }
  }

  onOpen() {
    this.setState({ open: true });
  }

  onClose() {
    this.setState({ open: false, selectedPlaylistId: undefined });
  }

  getSelectedPlaylist() {
    const filtered = this.props.viewer.playlists.edges.filter(
      p => p.node.id === this.state.selectedPlaylistId
    );
    return filtered.length > 0 ? filtered[0].node : null;
  }

  openPlaylist(id) {
    this.setState({ selectedPlaylistId: id, open: true });
  }

  deletePlaylist() {
    const onError = () => {
      GlobalNotifications.show({
        message: 'Unable to delete playlist',
        intent: Intent.DANGER
      });
    };

    const onCompleted = () => {
      this.onClose();
      Analytics.trackEvent('deleted-playlist');
    };

    const mutation = graphql`
      mutation Playlists_deletePlaylistMutation($input: DeletePlaylistInput!) {
        deletePlaylist(input: $input) {
          deletedPlaylistId
        }
      }
    `;

    const environment = this.props.relay.environment;

    const configs = [
      {
        type: 'RANGE_DELETE',
        parentID: this.props.viewer.id,
        pathToConnection: ['viewer', 'playlists'],
        deletedIDFieldName: 'deletedPlaylistId',
        connectionKeys: [
          {
            key: 'PlaylistsContainer_playlists',
            rangeBehavior: 'append'
          }
        ]
      }
    ];

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          id: this.getSelectedPlaylist().id
        }
      },
      configs,
      onCompleted,
      onError
    });
  }

  render() {
    const { relay, viewer } = this.props;
    const { open } = this.state;

    const AddPlaylistButton = (
      <Button
        primary
        icon='plus'
        labelPosition='left'
        content='Add Playlist'
      />
    );

    return (
      <RootConsumer>
        {({ isMobile }) => (
          <div>
            {!isMobile &&
              <Modal
                open={open}
                size='small'
                onClose={this.onClose}
                closeOnEscape={false}
                closeIcon
              >
                <Modal.Header content='View Playlist' />
                <Modal.Content>
                  {this.getSelectedPlaylist() &&
                    <UserPlaylist
                      playlistId={this.getSelectedPlaylist().id}
                      relay={relay}
                      deletePlaylist={this.deletePlaylist}
                    />}
                </Modal.Content>
              </Modal>}
            {isMobile &&
              <MobileModal
                open={open}
                onClose={this.onClose}
              >
                <MobileModal.Content>
                  {this.getSelectedPlaylist() &&
                    <UserPlaylist
                      playlistId={this.getSelectedPlaylist().id}
                      relay={relay}
                      goBack={this.onClose}
                      deletePlaylist={this.deletePlaylist}
                    />}
                </MobileModal.Content>
              </MobileModal>}
            {viewer.playlists.edges.map(({ node: playlist }, index) => (
              <PlaylistPreview
                playlist={playlist}
                key={index}
                following={!playlist.can_edit}
                openPlaylist={this.openPlaylist}
              />
            ))}
            {viewer.playlists.edges.length === 0 &&
              <div style={{ textAlign: 'center', padding: '2em' }}>
                <h3>You have no saved playlists</h3>
                <NewPlaylist
                  viewer={viewer}
                  relay={relay}
                  openPlaylist={this.openPlaylist}
                  trigger={AddPlaylistButton}
                />
              </div>}
            {viewer.playlists.edges.length > 0 &&
              <NewPlaylist
                viewer={viewer}
                relay={relay}
                openPlaylist={this.openPlaylist}
                trigger={<a>+ Add Playlist</a>}
              />}
          </div>
        )}
      </RootConsumer>
    );
  }
}

export default Playlists;



// WEBPACK FOOTER //
// ./webpack/components/App/Playlists.js